export const productHistoryReducer = (state = {loading: false, resulthistory: null, history: [], total: 0} , action) => {
    switch (action.type) {
        case 'PRODUCTHISTORY_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                history: action.payload.history || [],
                total: action.payload.total || 0
            }
        case 'PRODUCTHISTORY_RESET_RESULT':
            return {
                ...state,
                resulthistory: null
            }
        case 'PRODUCTHISTORY_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'PRODUCTHISTORY_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        case 'PRODUCTHISTORY_ERROR':
            return {
                ...state,
                loading: false,
                resulthistory: action.payload
            }
        default:
            return state
    }
}
